<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <Wxts :wxtsList="wxtsList" />

    <RadioMenu :menuIndex="menuIndex" :menu="menu" />

    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Wxts from '../../../components/Wxts.vue';
export default {
  name: "NonContractOrder",
  components: { Wxts },
  data() {
    return {
      breadcrumb: [
        { name: "运单管理" },
        { name: "普通运单" },
      ],
      wxtsList: [
        {
          name: '请先确认是否已经完成对客户、车辆、人员的创建，创建完成后方可派普通运单。'
        },
      ],
      menu: [
        {
          name: "自有车辆",
          path: '/order/nocontract/own',
        },
        {
          name: "外协车辆",
          path: '/order/nocontract/hire',
        },
      ],
      menuIndex: '/order/nocontract/own',
    };
  },
  methods: {
    onRouteChange() {
      if (this.$route.path.includes('/hire')) {
        this.wxtsList.push(
          {
            name: '应收运费=运费金额-亏吨金额+运单补差；'
          },
          {
            name: '应付运费=承运金额-亏吨金额。'
          },
        )
      } else {
        this.wxtsList.length = 1
      }
    },
  },
  watch: {
    $route() {
      this.onRouteChange()
    },
  },
  mounted() {
    this.menu.map(v => {
      if (this.$route.path.includes(v.path)) {
        this.menuIndex = v.path
      }
    })
  },
};
</script>

<style scoped></style>